var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassdoorJobScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.glassdoor{fill:url(#glassdoor-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glassdoor-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaced7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25529,
    stopColor: "#59bb8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#0daa41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d775f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "glassdoor",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M69.94124,36.28375h-10.05713v-3.72451c0-2.14789-1.74652-3.89441-3.89441-3.89441h-11.97939c-2.14735,0-3.89441,1.74652-3.89441,3.89441v3.72451h-10.05713c-1.17775,0-2.13244.95475-2.13244,2.13244v5.19196c0,2.88759,2.34085,5.22851,5.22851,5.22851h33.69033c2.88766,0,5.22851-2.34092,5.22851-5.22851v-5.19196c0-1.17768-.95469-2.13244-2.13244-2.13244ZM43.44838,32.55925c0-.31025.25167-.56192.56192-.56192h11.97939c.31025,0,.56192.25167.56192.56192v3.72451h-13.10323v-3.72451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M33.15483,53.27998c-1.9266,0-3.71908-.57264-5.22851-1.54739v17.47014c0,1.17768.95469,2.13244,2.13244,2.13244h39.88248c1.17775,0,2.13244-.95475,2.13244-2.13244v-17.47014c-1.50942.97476-3.30191,1.54739-5.22851,1.54739h-33.69033Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoorJobScraper);
export default __webpack_public_path__ + "static/media/glassdoor-job-scraper.993a956edacd761a7eeee89e65702814.svg";
export { ForwardRef as ReactComponent };